import { render, staticRenderFns } from "./customersaleprice.vue?vue&type=template&id=1efcf50c"
import script from "./customersaleprice.vue?vue&type=script&lang=js"
export * from "./customersaleprice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports